
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {GatewayModule} from '../core/GatewayModule';
import {FieldModelGatewayModule} from '../core/GatewayModule';

/**
 * GatewayModulesGetResponse struct
 */
class GatewayModulesGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Array=} gatewayModule
   * @constructor
   */
  constructor (parent = new Response(), gatewayModule = []) {
    super()
    super.copy(parent)
    this.GatewayModule = gatewayModule
  }

  /**
   * Copy struct (shallow copy)
   * @this {!GatewayModulesGetResponse}
   * @param {!GatewayModulesGetResponse} other Other struct
   * @returns {!GatewayModulesGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.GatewayModule != null) {
      this.GatewayModule = []
      for (let item of other.GatewayModule) {
        if (item != null) {
          let tempItem
          tempItem = GatewayModule.fromObject(item)
          this.GatewayModule.push(tempItem)
        } else {
          this.GatewayModule.push(null)
        }
      }
    } else {
      this.GatewayModule = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!GatewayModulesGetResponse}
   * @returns {!GatewayModulesGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new GatewayModulesGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new GatewayModulesGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!GatewayModulesGetResponse}
   * @param {!GatewayModulesGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof GatewayModulesGetResponse)) {
      throw new TypeError('Instance of GatewayModulesGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!GatewayModulesGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      GatewayModule: ((this.GatewayModule != null) ? Array.from(this.GatewayModule, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return GatewayModulesGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!GatewayModulesGetResponse} other Object value
   * @returns {!GatewayModulesGetResponse} Created struct
   */
  static fromObject (other) {
    return new GatewayModulesGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!GatewayModulesGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return GatewayModulesGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!GatewayModulesGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 8005
  }
}

export { GatewayModulesGetResponse };

/**
 * Fast Binary Encoding GatewayModulesGetResponse field model
 */
class FieldModelGatewayModulesGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.GatewayModule = new fbe.FieldModelVector(new FieldModelGatewayModule(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelGatewayModulesGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelGatewayModulesGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelGatewayModulesGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.GatewayModule.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelGatewayModulesGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.GatewayModule.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelGatewayModulesGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelGatewayModulesGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelGatewayModulesGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 8005
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelGatewayModulesGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelGatewayModulesGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.GatewayModule.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GatewayModule.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayModule.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelGatewayModulesGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelGatewayModulesGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelGatewayModulesGetResponse}
   * @param {!GatewayModulesGetResponse} fbeValue Default value, defaults is new GatewayModulesGetResponse()
   * @returns {!GatewayModulesGetResponse} GatewayModulesGetResponse value
   */
  get (fbeValue = new GatewayModulesGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelGatewayModulesGetResponse}
   * @param {!GatewayModulesGetResponse} fbeValue GatewayModulesGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.GatewayModule.fbeSize) <= fbeStructSize) {
      this.GatewayModule.get(fbeValue.GatewayModule)
    } else {
      fbeValue.GatewayModule.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayModule.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelGatewayModulesGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelGatewayModulesGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelGatewayModulesGetResponse}
   * @param {!GatewayModulesGetResponse} fbeValue GatewayModulesGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelGatewayModulesGetResponse}
   * @param {GatewayModulesGetResponse} fbeValue GatewayModulesGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.GatewayModule.set(fbeValue.GatewayModule)
  }
}

export { FieldModelGatewayModulesGetResponse };

/**
 * Fast Binary Encoding GatewayModulesGetResponse model
 */
class GatewayModulesGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelGatewayModulesGetResponse(this.buffer, 4)
  }

  /**
   * Get the GatewayModulesGetResponse model
   * @this {!GatewayModulesGetResponseModel}
   * @returns {!FieldModelGatewayModulesGetResponse} model GatewayModulesGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!GatewayModulesGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!GatewayModulesGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return GatewayModulesGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!GatewayModulesGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelGatewayModulesGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!GatewayModulesGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!GatewayModulesGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!GatewayModulesGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!GatewayModulesGetResponseModel}
   * @param {!GatewayModulesGetResponse} value GatewayModulesGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!GatewayModulesGetResponseModel}
   * @param {!GatewayModulesGetResponse} value GatewayModulesGetResponse value, defaults is new GatewayModulesGetResponse()
   * @return {!object} Deserialized GatewayModulesGetResponse value and its size
   */
  deserialize (value = new GatewayModulesGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new GatewayModulesGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new GatewayModulesGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!GatewayModulesGetResponseModel}
   * @param {!number} prev Previous GatewayModulesGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { GatewayModulesGetResponseModel };
